// src/XIcon.tsx
import { jsx } from "react/jsx-runtime";
var XIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "23",
    height: "21",
    viewBox: "0 0 23 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M14.47 8.27372L22.2414 0.0253906H19.2903L13.1907 6.50047L8.51938 0.0253906H0.447266L8.61801 11.352L0.447266 20.0254H3.3984L9.89825 13.1262L14.8752 20.0254H22.9473L14.47 8.27372ZM4.60613 2.14601H7.41996L18.7874 17.9029H15.9736L4.60613 2.14601Z" })
  }
);
var XIcon_default = XIcon;

export {
  XIcon_default
};
